export default __webpack_public_path__ + "static/media/logo.742d070f.jpeg";